import style from './about-us-section.module.scss';
import template from '@components/careers/vacancies/vacancies.module.scss';
import Image from 'next/image';
import { useEffect, useState } from 'react';
import { IVideo } from '@components/careers/vacancies/vacancies.interfaces';

interface IAboutUsSection {
  title: string;
  text: string[];
  imageSrc: string;
  video: IVideo[];
}

const AboutUsSection = ({ title, text, imageSrc, video }: IAboutUsSection) => {
  function isLastIndex(index: number, arrayLength: number) {
    return index === arrayLength - 1;
  }
  //TODO: add video playing
  useEffect(() => {
    let overlay = document.getElementById('video-overlay') as HTMLElement,
      video = document.getElementById('video') as HTMLVideoElement;
    video.volume = 0.05;
    function hideOverlay() {
      overlay.style.display = 'none';
      video.play();
    }

    function showOverlay() {
      if (video.readyState === 4) {
        overlay.style.display = 'block';
        video.pause();
      }
    }
    video.addEventListener('click', showOverlay);
    overlay.addEventListener('click', hideOverlay);
    return function () {
      video.removeEventListener('click', showOverlay);
      overlay.removeEventListener('click', hideOverlay);
    };
  }, []);

  return (
    <section className={`${template.section} ${template.section_light}`}>
      <div
        className={`${template.container} ${template.container_large} ${template.flex} ${template.flex_justify_content_space_between} ${style.flex}`}
      >
        <div className={`${style.textblock}`}>
          <div className={`${template.title} ${template.title_large} ${template.text_align_l} ${template.mb20}`}>
            {title}
          </div>
          {text.map((item: string, index: number) => {
            return (
              <div
                key={index}
                className={`${template.text} ${template.text_color_main} ${template.text_small} ${template.text_align_l} ${isLastIndex(index, text.length) ? null : template.mb16} `}
              >
                {item}
              </div>
            );
          })}
        </div>
        <div className={`${style.video__wrapper}`}>
          <div className={`${style.poster}`} id="video-overlay">
            <Image alt="preview-video" src={imageSrc} layout="fill" sizes="600 400 200" />
            <div className={`${style.poster__play}`}>
              <Image alt="play icon" src={'/vacancies-images/icons/play.png'} width="68" height="68" />
            </div>
          </div>
          <video id={'video'} className={`${style.video}`}>
            {video.map((item: IVideo, index: number) => {
              return <source key={index} src={item.videoSrc} type={item.format}></source>;
            })}
          </video>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;
